export const french: Record<string, string> = {
  'Employee category': 'Cat\u00e9gorie du salari\u00e9',
  CADRE: 'CADRE',
  NON_CADRE: 'NON-CADRE',
  'Add document': 'Ajouter un document',
  'Select document type': 'S\u00e9lectionner le type de document',
  'Document file': 'Fichier du document',
  'Uploading document...': 'Envoi du document...',
  'Document type': 'Type de document',
  'ID card': "Carte d'identit\u00e9",
  Passport: 'Passeport',
  'Medical prescription': 'Ordonnance m\u00e9dicale',
  Invoice: 'Facture',
  'Other document': 'Autre document',
  'Document pending': 'En attente de validation',
  'Document validated': 'Valid\u00e9',
  'Document rejected': 'Rejet\u00e9',
  'Review document': 'Examiner le document',
  'Validation status': 'Statut de validation',
  'Review reason': 'Motif de la d\u00e9cision',
  'Save validation': 'Enregistrer la validation',
  'Validation history': 'Historique de validation',
  'Document history': 'Historique des documents',
  'Close history': "Fermer l'historique",
  'No validation history': 'Aucun historique de validation',
  'Document validation updated.': 'Validation du document mise \u00e0 jour.',
  'Unable to update document validation.': 'Impossible de mettre \u00e0 jour la validation.',
  'Unable to load validation history.': "Impossible de charger l'historique de validation.",
  'Document changed. Refresh before reviewing again.': 'Le document a chang\u00e9. Actualisez avant de reprendre la validation.',
  'Document uploaded': 'Document ajout\u00e9',
  'Validation changed': 'Validation modifi\u00e9e',
  'Document deleted': 'Document supprim\u00e9',
  Documents: 'Documents',
  'Upload document': 'Ajouter un document',
  'Refresh documents': 'Actualiser les documents',
  'Download document': 'T\u00e9l\u00e9charger le document',
  'Delete document': 'Supprimer le document',
  'Delete document?': 'Supprimer le document ?',
  'Loading documents...': 'Chargement des documents...',
  'No documents': 'Aucun document',
  'Document uploaded.': 'Document ajout\u00e9.',
  'Document deleted.': 'Document supprim\u00e9.',
  'Unable to load documents.': 'Impossible de charger les documents.',
  'Unable to upload document.': 'Impossible d\u2019ajouter le document.',
  'Unable to download document.': 'Impossible de t\u00e9l\u00e9charger le document.',
  'Unable to delete document.': 'Impossible de supprimer le document.',
  'Select a non-empty document.': 'S\u00e9lectionnez un document non vide.',
  'Document must not exceed 10 MB.': 'Le document ne doit pas d\u00e9passer 10 Mo.',
  'Only PDF, JPEG and PNG documents are supported.': 'Seuls les documents PDF, JPEG et PNG sont accept\u00e9s.',
  'Document access denied.': 'Acc\u00e8s au document refus\u00e9.',
  'Document or record not found.': 'Document ou dossier introuvable.',
  'Picture URL': 'URL de la photo',
  'IPM home': 'Accueil IPM',
  'IPM Workspace': 'Espace IPM',
  'Provident management': 'Gestion de la pr\u00e9voyance',
  WORKSPACE: 'ESPACE DE TRAVAIL',
  'Management sections': 'Rubriques de gestion',
  Operations: 'Gestion',
  Configuration: 'Configuration',
  Banks: 'Banques',
  'Bank name': 'Nom de la banque',
  BIC: 'BIC',
  bank: 'banque',
  'payment desk': 'guichet de paiement',
  'Payment desks': 'Guichets de paiement',
  'new.banks': 'Nouvelle banque',
  'new.payment-desks': 'Nouveau guichet',
  'Bank not found': 'Banque introuvable',
  'Bank BIC already exists': 'Ce BIC bancaire existe d\u00e9j\u00e0',
  'Bank is in use': 'Cette banque est utilis\u00e9e',
  'Payment desk not found': 'Guichet de paiement introuvable',
  'Payment desk name already exists': 'Ce nom de guichet existe d\u00e9j\u00e0',
  'Payment desk is in use': 'Ce guichet de paiement est utilis\u00e9',
  Language: 'Langue',
  Theme: 'Th\u00e8me',
  French: 'Fran\u00e7ais',
  English: 'Anglais',
  Wolof: 'Wolof',
  Light: 'Clair',
  Dark: 'Sombre',
  System: 'Syst\u00e8me',
  Ocean: 'Oc\u00e9an',
  Rose: 'Rose',
  'High contrast': 'Contraste \u00e9lev\u00e9',
  'API connected': 'API connect\u00e9e',
  'Not connected': 'Non connect\u00e9',
  'Health coverage operations': 'Gestion de la couverture sant\u00e9',
  'Coordinate member coverage in one workspace.': 'Coordonnez la couverture des adh\u00e9rents dans un espace de travail unique.',
  'Bring members, claims, guarantee letters, and contributions together in one clear workspace.': 'Rassemblez les adh\u00e9rents, les demandes de remboursement, les lettres de garantie et les cotisations dans un espace clair.',
  'Explore capabilities': 'D\u00e9couvrir les fonctionnalit\u00e9s',
  'Built for connected coverage work': 'Con\u00e7u pour une gestion coordonn\u00e9e de la couverture',
  'One view for the work behind member care.': 'Une vue d\u2019ensemble sur la gestion des adh\u00e9rents.',
  'Member and dependent records': 'Dossiers des adh\u00e9rents et ayants droit',
  'Keep profiles, contracts, eligibility, and family details organized.': 'Organisez les profils, contrats, droits et informations familiales.',
  'Claims and guarantee letters': 'Demandes et lettres de garantie',
  'Follow reimbursements and guarantee letters through their workflows.': 'Suivez les remboursements et les lettres de garantie dans leurs parcours.',
  'Contributions and reporting': 'Cotisations et rapports',
  'Review contribution activity alongside ledger and operational reports.': 'Consultez les cotisations, le grand livre et les rapports de gestion.',
  'One sign-in for members, institutions, and employers.': 'Un seul acc\u00e8s pour les adh\u00e9rents, organismes et employeurs.',
  'Healthcare team speaking with a patient': '\u00c9quipe de sant\u00e9 en consultation avec un patient',
  'Back to welcome page': 'Retour \u00e0 l\u2019accueil',
  'Sign in': 'Se connecter',
  'Sign-in type': 'Type de connexion',
  'Staff access': 'Acc\u00e8s gestionnaire',
  'Member access': 'Acc\u00e8s adh\u00e9rent',
  'Member sign in': 'Connexion adh\u00e9rent',
  'Member username': "Nom d'utilisateur adh\u00e9rent",
  'Member access requires a member account.': 'Cette connexion est r\u00e9serv\u00e9e aux adh\u00e9rents.',
  'Member accounts should use Member access.': 'Choisissez Acc\u00e8s adh\u00e9rent pour ce compte.',
  'Member portal': 'Espace adh\u00e9rent',
  'Member portal sections': 'Rubriques de l\u2019espace adh\u00e9rent',
  'My information': 'Mes informations',
  'My dependents': 'Mes ayants droit',
  'My claims': 'Mes demandes',
  'My guarantee letters': 'Mes lettres de garantie',
  'Sign out': 'Se d\u00e9connecter',
  'Account menu for': 'Menu du compte de {{username}}',
  'Account details': 'D\u00e9tails du compte',
  'My details': 'Mes informations',
  'Back to account menu': 'Retour au menu du compte',
  'Application version': "Version de l'application",
  Role: 'R\u00f4le',
  'Institution name': 'Institution',
  'Institution role': "R\u00f4le dans l'institution",
  Reporting: 'Rapports',
  'Reporting submenus': 'Sous-menus des rapports',
  Processing: 'Traitement',
  'Processing actions': 'Actions de traitement',
  'Batches today': 'Lots du jour',
  'Refresh batch history': 'Actualiser l\'historique des lots',
  'Loading batch history...': 'Chargement de l\'historique des lots...',
  'Unable to load batch history.': 'Impossible de charger l\'historique des lots.',
  'No batches today.': 'Aucun lot aujourd\'hui.',
  Started: 'Démarré',
  Batch: 'Lot',
  Result: 'Résultat',
  'Generate contributions': 'G\u00e9n\u00e9rer les cotisations',
  'Copy salaries': 'Copier les salaires',
  'Source year': 'Ann\u00e9e source',
  'Source month': 'Mois source',
  'Target year': 'Ann\u00e9e cible',
  'Target month': 'Mois cible',
  'Source and target periods must be different.': 'Les p\u00e9riodes source et cible doivent \u00eatre diff\u00e9rentes.',
  'Start salary copy': 'Lancer la copie des salaires',
  'Salary copy batch started.': 'La copie des salaires a d\u00e9marr\u00e9.',
  'Salaries copied.': 'Les salaires ont \u00e9t\u00e9 copi\u00e9s.',
  'Salary copy batch failed.': 'La copie des salaires a \u00e9chou\u00e9.',
  'Contribution report': 'Rapport des cotisations',
  'Load report': 'Charger le rapport',
  'Loading contribution report...': 'Chargement du rapport des cotisations...',
  'Unable to load contribution report.': 'Impossible de charger le rapport des cotisations.',
  'No contributions for this period.': 'Aucune cotisation pour cette p\u00e9riode.',
  'Member rate (%)': 'Taux adh\u00e9rent (%)',
  'Company rate (%)': 'Taux entreprise (%)',
  'Member contribution': 'Cotisation adh\u00e9rent',
  'Company contribution': 'Cotisation entreprise',
  'Paid amount': 'Montant pay\u00e9',
  'Contributions generated.': 'Les cotisations ont \u00e9t\u00e9 g\u00e9n\u00e9r\u00e9es.',
  'No new contributions to generate.': 'Aucune nouvelle cotisation \u00e0 g\u00e9n\u00e9rer.',
  'Ledger report': 'Rapport du grand livre',
  'Audit report': "Rapport d'audit",
  'Guarantee letters report': 'Rapport des lettres de garantie',
  'Claims report': 'Rapport des demandes',
  'Journal reference': 'R\u00e9f\u00e9rence journal',
  'Date and time': 'Date et heure',
  'Account code': 'Code compte',
  Account: 'Compte',
  Accounts: 'Comptes',
  account: 'compte',
  'Account name': 'Nom du compte',
  'Account type': 'Type de compte',
  ASSET: 'Actif', LIABILITY: 'Passif', EQUITY: 'Capitaux propres', REVENUE: 'Produits', EXPENSE: 'Charges',
  Debit: 'D\u00e9bit',
  Credit: 'Cr\u00e9dit',
  Currency: 'Devise',
  Locked: 'Verrouill\u00e9',
  'Created at': 'Cr\u00e9\u00e9 le',
  'Created by': 'Cr\u00e9\u00e9 par',
  'Last modified at': 'Modifi\u00e9 le',
  'Last modified by': 'Modifi\u00e9 par',
  Lines: 'Lignes',
  'Locked by': 'Verrouill\u00e9 par',
  'Institution reimbursement': 'Part institution',
  OPERATOR: 'Op\u00e9rateur', INSTITUTION: 'Institution', ADMIN: 'Administrateur', USER: 'Utilisateur',
  Username: "Nom d'utilisateur",
  Email: 'E-mail',
  Password: 'Mot de passe',
  'Show password': 'Afficher le mot de passe',
  'Hide password': 'Masquer le mot de passe',
  'Member login username': "Nom d'utilisateur de l'espace adh\u00e9rent",
  'Member login password': "Mot de passe de l'espace adh\u00e9rent",
  'Connecting...': 'Connexion en cours...',
  Members: 'Adh\u00e9rents',
  Dependents: 'Ayants droit',
  Claims: 'Remboursement',
  Contracts: 'Contrats',
  Companies: 'Entreprises',
  Company: 'Entreprise',
  company: 'entreprise',
  Institutions: 'Institutions',
  institution: 'institution',
  'Legal name': 'Raison sociale',
  'Industry sector': "Secteur d'activit\u00e9",
  SUPER_ADMIN: 'Super administrateur',
  COMPANY: 'Entreprise',
  'new.companies': 'Nouvelle entreprise',
  'Insurer providers': 'Organismes assureurs',
  Treatments: 'Actes de soins',
  'Healthcare providers': 'Professionnels de sant\u00e9',
  'Healthcare provider': 'Professionnel de sant\u00e9',
  Drugstores: 'Pharmacies',
  Physicians: 'M\u00e9decins',
  drugstore: 'pharmacie',
  physician: 'm\u00e9decin',
  'new.drugstores': 'Nouvelle pharmacie',
  'new.physicians': 'Nouveau m\u00e9decin',
  Drugs: 'M\u00e9dicaments',
  member: 'adh\u00e9rent',
  dependent: 'ayant droit',
  claim: 'demande de remboursement',
  contract: 'contrat',
  'insurer provider': 'organisme assureur',
  treatment: 'acte de soins',
  'healthcare provider': 'professionnel de sant\u00e9',
  drug: 'm\u00e9dicament',
  'new.members': 'Nouvel adh\u00e9rent',
  'new.dependents': 'Nouvel ayant droit',
  'new.claims': 'Nouvelle demande',
  'new.contracts': 'Nouveau contrat',
  'new.providers': 'Nouvel organisme assureur',
  'new.treatments': 'Nouvel acte de soins',
  'new.healthcare': 'Nouveau professionnel de sant\u00e9',
  'new.drugs': 'Nouveau m\u00e9dicament',
  'MEMBER OPERATIONS': 'GESTION DES ADH\u00c9RENTS',
  'REFERENCE & COVERAGE': 'R\u00c9F\u00c9RENTIELS ET COUVERTURE',
  'Search records': 'Rechercher des enregistrements',
  'Search section': 'Rechercher : {{section}}',
  'Refresh records': 'Actualiser les enregistrements',
  'Select a member': 'S\u00e9lectionner un adh\u00e9rent',
  'Select a member.': 'S\u00e9lectionnez un adh\u00e9rent.',
  Actions: 'Actions',
  'Claim details': 'D\u00e9tails de la demande',
  'Member details': "D\u00e9tails de l'adh\u00e9rent",
  'Record details': "D\u00e9tails de l'enregistrement",
  'Edit member': "Modifier l'adh\u00e9rent",
  'Dependent details': "D\u00e9tails de l'ayant droit",
  'Manage dependents': 'G\u00e9rer les ayants droit',
  'No dependents': 'Aucun ayant droit',
  'No claims': 'Aucune demande de remboursement',
  'Guarantee letters': 'Prise en charge',
  'Guarantee lines': 'Prestations garanties',
  'Add guarantee line': 'Ajouter une prestation garantie',
  'Update guarantee lines': 'Modifier les prestations garanties',
  'Save guarantee lines': 'Enregistrer les prestations garanties',
  'Validate guarantee letter': 'Valider la lettre de garantie',
  'Cancel guarantee-letter payment': 'Annuler le paiement de la lettre de garantie',
  'Guarantee-letter payment cancelled.': 'Paiement de la lettre de garantie annule.',
  'Unable to cancel guarantee-letter payment.': "Impossible d'annuler le paiement de la lettre de garantie.",
  'Mark guarantee letter as paid': 'Marquer la lettre de garantie comme pay e9e',
  'Guarantee letter marked as paid.': 'Lettre de garantie marqu e9e comme pay e9e.',
  'Unable to pay guarantee letter.': 'Impossible de r e9gler la lettre de garantie.',
  'No guarantee lines': 'Aucune prestation garantie',
  'Guaranteed total': 'Total garanti',
  'Add at least one guarantee line.': 'Ajoutez au moins une prestation garantie.',
  'Select an item and a positive amount for every guarantee line.': 'Choisissez une prestation et un montant positif pour chaque ligne.',
  'Guarantee letter details': 'D\u00e9tails de la lettre de garantie',
  'Edit guarantee letter': 'Modifier la lettre de garantie',
  'Download guarantee letter PDF': 'T\u00e9l\u00e9charger la lettre de garantie en PDF',
  'Print guarantee letter PDF': 'Imprimer la lettre de garantie en PDF',
  'Cancel guarantee letter': 'Annuler la lettre de garantie',
  'Unable to cancel guarantee letter.': 'Impossible d\u2019annuler la lettre de garantie.',
  'Unable to download guarantee letter PDF.': 'Impossible de t\u00e9l\u00e9charger la lettre de garantie en PDF.',
  'guarantee letter': 'lettre de garantie',
  'new.letters': 'Nouvelle lettre de garantie',
  'No guarantee letters': 'Aucune lettre de garantie',
  'Loading guarantee letters...': 'Chargement des lettres de garantie...',
  'Unable to load guarantee letters.': 'Impossible de charger les lettres de garantie.',
  Reference: 'R\u00e9f\u00e9rence',
  'Issue date': "Date d'\u00e9mission",
  'Valid until': "Date d'expiration",
  'Enter valid dates in dd/mm/yyyy order.': 'Saisissez des dates valides au format jj/mm/aaaa et dans le bon ordre.',
  'Guaranteed amount': 'Montant garanti',
  Notes: 'Notes',
  DRAFT: 'Brouillon',
  ISSUED: '\u00c9mise',
  VALIDATED: 'Valid\u00e9e',
  CANCELLED: 'Annul\u00e9e',
  EXPIRED: 'Expir\u00e9e',
  'The expiry date must not precede the issue date': "La date d'expiration ne doit pas pr\u00e9c\u00e9der la date d'\u00e9mission",
  'Loading claims...': 'Chargement des demandes...',
  'Unable to load claims.': 'Impossible de charger les demandes de remboursement.',
  Retry: 'R\u00e9essayer',
  Beneficiary: 'B\u00e9n\u00e9ficiaire',
  'Process claim': 'Traiter la demande',
  'Processing claim...': 'Traitement de la demande en cours...',
  'Reject claim': 'Rejeter la demande',
  'Rejecting claim...': 'Rejet de la demande en cours...',
  'Record payment': 'Enregistrer le paiement',
  'Recording payment...': 'Enregistrement du paiement en cours...',
  'Payment date': 'Date de paiement',
  'Payment type': 'Mode de paiement',
  'Select a payment type': 'Choisissez un mode de paiement',
  'Payment desk': 'Guichet de paiement',
  Bank: 'Banque',
  'Select a bank': 'Choisissez une banque',
  'Loading banks...': 'Chargement des banques...',
  'Unable to load banks.': 'Impossible de charger les banques.',
  'No banks available.': 'Aucune banque disponible.',
  'Bank account number': 'Num\u00e9ro de compte bancaire',
  'Bank account BIC': 'BIC du compte bancaire',
  'Mobile number': 'Num\u00e9ro de mobile',
  'Payment reference': 'R\u00e9f\u00e9rence de paiement',
  'Payment reference (optional)': 'R\u00e9f\u00e9rence de paiement (facultative)',
  'Payment is recorded after an external transfer.': 'Le paiement est enregistr\u00e9 apr\u00e8s un virement externe.',
  'Edit record': "Modifier l'enregistrement",
  'Deactivate record': "D\u00e9sactiver l'enregistrement",
  'Delete record': "Supprimer l'enregistrement",
  'Remove record': "Retirer l'enregistrement",
  'Loading records...': 'Chargement des enregistrements...',
  'No matching records': 'Aucun r\u00e9sultat',
  'No records': 'Aucun enregistrement',
  'recordCount.one': '{{count}} enregistrement',
  'recordCount.other': '{{count}} enregistrements',
  'Previous page': 'Page pr\u00e9c\u00e9dente',
  'Next page': 'Page suivante',
  'EDIT RECORD': "MODIFIER L'ENREGISTREMENT",
  'NEW RECORD': 'NOUVEL ENREGISTREMENT',
  'Close editor': 'Fermer le formulaire',
  'Close details': 'Fermer les d\u00e9tails',
  'Select...': 'S\u00e9lectionner...',
  None: 'Aucun',
  'Guarantee packages': 'Offres de garanties',
  'Guarantee package': 'Offre de garanties',
  'Guarantee name': "Nom de l'offre",
  'New guarantee packages': 'Nouvelles offres de garanties',
  'Add guarantee package': 'Ajouter une offre de garanties',
  'Remove guarantee package': 'Retirer une offre de garanties',
  'Guarantee details': "D\u00e9tails de l'offre de garanties",
  'Social Security reimbursement rate (%)': 'Taux de remboursement de la S\u00e9curit\u00e9 sociale (%)',
  'Member reimbursement rate (%)': "Taux de remboursement \u00e0 la charge de l'adh\u00e9rent (%)",
  'Member tax rate (%)': 'Taux de cotisation adh\u00e9rent (%)',
  'Company tax rate (%)': 'Taux de cotisation entreprise (%)',
  'Delete guarantee package': 'Supprimer une offre de garanties',
  'Delete guarantee package?': 'Supprimer cette offre de garanties ?',
  'Guarantee package deleted.': 'Offre de garanties supprim\u00e9e.',
  'Guarantee packages used by contracts cannot be deleted.': 'Une offre de garanties utilis\u00e9e par un contrat ne peut pas \u00eatre supprim\u00e9e.',
  'No caps available': 'Aucun plafond disponible',
  'Refresh members': 'Actualiser les adh\u00e9rents',
  'Company details': "D\u00e9tails de l'entreprise",
  'Loading company members...': "Chargement des adh\u00e9rents de l'entreprise...",
  'Unable to load company members.': "Impossible de charger les adh\u00e9rents de l'entreprise.",
  'No members attached to this company.': 'Aucun adh\u00e9rent rattach\u00e9 \u00e0 cette entreprise.',
  'Monthly salaries': 'Salaires',
  Contributions: 'Cotisations',
  'Refresh contributions': 'Actualiser les cotisations',
  'Loading contributions...': 'Chargement des cotisations...',
  'Unable to load member contributions.': 'Impossible de charger les cotisations de cet adh\u00e9rent.',
  'No contributions for this member.': 'Aucune cotisation pour cet adh\u00e9rent.',
  'Mark as paid': 'Marquer comme pay\u00e9e',
  'Mark contribution as paid?': 'Marquer cette cotisation comme pay\u00e9e ?',
  'Outstanding amount': 'Montant restant',
  'Contribution marked as paid.': 'Cotisation marqu\u00e9e comme pay\u00e9e.',
  'Cancel payment': 'Annuler le paiement',
  'Cancel contribution payment?': 'Annuler le paiement de cette cotisation ?',
  'Cancelling payment...': 'Annulation du paiement...',
  'Contribution payment cancelled.': 'Paiement de la cotisation annul\u00e9.',
  'Cancel contribution': 'Annuler la cotisation',
  'Cancel this contribution?': 'Annuler cette cotisation ?',
  'Cancelling contribution...': 'Annulation de la cotisation...',
  'Contribution cancelled.': 'Cotisation annul\u00e9e.',
  'Unable to cancel contribution. Refresh and try again.': 'Impossible d\u2019annuler la cotisation. Actualisez et r\u00e9essayez.',
  'Unable to cancel contribution payment. Refresh and try again.': 'Impossible d\u2019annuler le paiement. Actualisez et r\u00e9essayez.',
  'Unable to record contribution payment. Refresh and try again.': 'Impossible d\u2019enregistrer le paiement de la cotisation. Actualisez et r\u00e9essayez.',
  Year: 'Ann\u00e9e',
  Month: 'Mois',
  'Gross salary': 'Salaire brut',
  Period: 'P\u00e9riode',
  'Refresh monthly salaries': 'Actualiser les salaires mensuels',
  'Loading monthly salaries...': 'Chargement des salaires mensuels...',
  'Unable to load monthly salaries.': 'Impossible de charger les salaires mensuels.',
  'Unable to load member salaries.': 'Impossible de charger les salaires de cet adh\u00e9rent.',
  'No monthly salaries for this member.': 'Aucun salaire mensuel pour cet adh\u00e9rent.',
  'Unable to add monthly salary.': 'Impossible d\'ajouter le salaire mensuel.',
  'Unable to update monthly salary.': 'Impossible de mettre \u00e0 jour le salaire mensuel.',
  'Monthly salary already exists for this member and period.': 'Un salaire existe d\u00e9j\u00e0 pour cet adh\u00e9rent et cette p\u00e9riode.',
  'No monthly salaries recorded for this company.': 'Aucun salaire mensuel enregistr\u00e9 pour cette entreprise.',
  'Refresh the company members list before adding a salary.': 'Actualisez la liste des adh\u00e9rents avant d\'ajouter un salaire.',
  'Add monthly salary': 'Ajouter un salaire mensuel',
  'Edit monthly salary': 'Modifier le salaire mensuel',
  'Update monthly salary': 'Mettre \u00e0 jour le salaire mensuel',
  'Risk type': 'Type de risque',
  Caps: 'Plafonds',
  'Cap type': 'Type de plafond',
  'Maximum amount': 'Montant maximum',
  'Maximum quantity': 'Quantit\u00e9 maximale',
  HEALTH: 'Sant\u00e9',
  DISABILITY: 'Invalidit\u00e9',
  LIFE_INSURANCE: 'Assurance d\u00e9c\u00e8s',
  RETIREMENT: 'Retraite',
  ANNUAL_BUDGET: 'Budget annuel',
  PER_ACT_MAX: 'Maximum par acte',
  QUANTITY_PER_YEAR: 'Quantit\u00e9 par an',
  'No guarantee packages available': 'Aucune offre de garanties disponible',
  'Claim lines': 'Lignes de soins',
  'Add claim line': 'Ajouter une ligne de soins',
  Line: 'Ligne',
  'Item type': "Type d'\u00e9l\u00e9ment",
  Treatment: 'Acte de soins',
  Drug: 'M\u00e9dicament',
  'Guarantee letter type': 'Type de lettre de garantie',
  'Healthcare provider type': 'Type de prestataire de santé',
  'Payment details': 'Informations de paiement',
  'Select a payment desk': 'Choisir une caisse',
  'Loading payment sources...': 'Chargement des moyens de paiement...',
  'No payment desks available.': 'Aucune caisse disponible.',
  TREATMENT: 'Traitement',
  PRESCRIPTION: 'Prescription',
  Item: '\u00c9l\u00e9ment',
  'Billed amount': 'Montant factur\u00e9',
  'Payment destination': 'Destinataire du paiement',
  'Remove line': 'Supprimer la ligne',
  Cancel: 'Annuler',
  'Saving...': 'Enregistrement en cours...',
  'Save changes': 'Enregistrer les modifications',
  'Submit claim': 'Soumettre la demande',
  'Create record': "Cr\u00e9er l'enregistrement",
  'Delete record?': 'Supprimer cet enregistrement ?',
  'Deactivate record?': 'D\u00e9sactiver cet enregistrement ?',
  Confirm: 'Confirmer',
  Member: 'Adh\u00e9rent',
  Address: 'Adresse',
  'See more': 'Voir plus',
  'See less': 'Voir moins',
  'House number': 'Num\u00e9ro de voie',
  Street: 'Voie',
  'Address complement': "Compl\u00e9ment d'adresse",
  'Postal code': 'Code postal',
  City: 'Ville',
  Country: 'Pays',
  Dependent: 'Ayant droit',
  Claim: 'Demande',
  Contract: 'Contrat',
  Provider: 'Professionnel de sant\u00e9',
  Institution: 'Organisme assureur',
  'First name': 'Pr\u00e9nom',
  'Last name': 'Nom',
  'Social security number': 'Num\u00e9ro de s\u00e9curit\u00e9 sociale',
  'Social security reimbursement rate (%)': 'Taux de remboursement de la S\u00e9curit\u00e9 sociale (%)',
  'Provident institution reimbursement rate (%)': 'Taux de remboursement de l\u2019organisme de pr\u00e9voyance (%)',
  'Out-of-pocket rate (%)': 'Taux de reste \u00e0 charge (%)',
  'Reimbursement breakdown': 'R\u00e9partition du remboursement',
  'Member amount': 'Part adh\u00e9rent',
  'Social Security amount': 'Part S\u00e9curit\u00e9 sociale',
  'Provident institution amount': 'Part organisme de pr\u00e9voyance',
  Active: 'Actif',
  Inactive: 'Inactif',
  Yes: 'Oui',
  No: 'Non',
  Status: 'Statut',
  Affiliated: 'Date d\u2019affiliation',
  'Affiliation date': 'Date d\u2019affiliation',
  'Birth date': 'Date de naissance',
  'Place of birth': 'Lieu de naissance',
  Relationship: 'Lien de parent\u00e9',
  'Treatment date': 'Date des soins',
  'Practitioner identifier': 'Identifiant du praticien',
  'Company SIRET': "SIRET de l'entreprise",
  'Insurer provider': 'Organisme assureur',
  'Start date': 'Date de d\u00e9but',
  'End date': 'Date de fin',
  'Pick start date': 'Choisir la date de d\u00e9but',
  'Pick end date': 'Choisir la date de fin',
  'Download report PDF': 'T\u00e9l\u00e9charger le rapport PDF',
  'Contract number': 'Num\u00e9ro de contrat',
  'Collective agreement': 'Convention collective',
  SIREN: 'SIREN',
  'Regulatory code': 'Code r\u00e9glementaire',
  'Corporate name': 'Raison sociale',
  Code: 'Code',
  Description: 'Description',
  'Base price': 'Tarif de base',
  'Treatment code': "Code de l'acte",
  'Social security base price': 'Base de remboursement de la S\u00e9curit\u00e9 sociale',
  'RPPS code': 'Code RPPS',
  Type: 'Type',
  'Third-party agreement': 'Convention de tiers payant',
  'Provider name': 'Nom du professionnel',
  'Provider type': 'Type de professionnel',
  IBAN: 'IBAN',
  'CIS code': 'Code CIS',
  'Reimbursement rate (%)': 'Taux de remboursement (%)',
  'Drug name': 'Nom du m\u00e9dicament',
  'Social security rate (%)': 'Taux de remboursement de la S\u00e9curit\u00e9 sociale (%)',
  Billed: 'Factur\u00e9',
  'Social security': 'S\u00e9curit\u00e9 sociale',
  'Provident reimbursement': 'Remboursement de pr\u00e9voyance',
  'Out of pocket': 'Reste \u00e0 charge',
  PENDING: 'En attente',
  PROCESSED: 'Trait\u00e9e',
  REJECTED: 'Rejet\u00e9e',
  PAID: 'Pay\u00e9e',
  PARTIALLY_PAID: 'Partiellement pay\u00e9e',
  CASH: 'Esp\u00e8ces',
  BANK_TRANSFER: 'Virement bancaire',
  MOBILE_WALLET: 'Portefeuille mobile',
  SPOUSE: 'Conjoint',
  CHILD: 'Enfant',
  OTHER_DEPENDENT: 'Autre ayant droit',
  PHARMACY: 'Pharmacie',
  HOSPITAL: 'H\u00f4pital',
  OPTICIAN: 'Opticien',
  DENTIST: 'Dentiste',
  PHYSICIAN: 'M\u00e9decin',
  'Changes saved.': 'Modifications enregistr\u00e9es.',
  'Record created.': 'Enregistrement cr\u00e9\u00e9.',
  'Record deactivated.': 'Enregistrement d\u00e9sactiv\u00e9.',
  'Record deleted.': 'Enregistrement supprim\u00e9.',
  'Claim processed.': 'Demande trait\u00e9e.',
  'Claim rejected.': 'Demande rejet\u00e9e.',
  'Claim payment recorded.': 'Paiement de la demande enregistr\u00e9.',
  'Authentication failed. Check your username and password.': "\u00c9chec de l'authentification. V\u00e9rifiez votre nom d'utilisateur et votre mot de passe.",
  'Cannot reach the API. Check that the API server is running.': "Impossible de joindre l'API. V\u00e9rifiez que le serveur est d\u00e9marr\u00e9.",
  'Request failed': '\u00c9chec de la requ\u00eate ({{status}}).',
  'An unexpected error occurred.': 'Une erreur inattendue est survenue.',
  'Provider has linked contracts': 'Cet organisme assureur est li\u00e9 \u00e0 des contrats.',
  'Contract has linked members': 'Ce contrat est li\u00e9 \u00e0 des adh\u00e9rents.',
  'End date must not precede start date': 'La date de fin ne peut pas pr\u00e9c\u00e9der la date de d\u00e9but.',
  'Contract dates must include existing member affiliations': "Les dates du contrat doivent inclure les dates d'affiliation des adh\u00e9rents existants.",
  'Contract number already exists': 'Ce num\u00e9ro de contrat existe d\u00e9j\u00e0.',
  'SIREN already exists': 'Ce SIREN existe d\u00e9j\u00e0.',
  'Guarantee package not found': 'Offre de garanties introuvable.',
  'Provider not found': 'Organisme assureur introuvable.',
  'Contract not found': 'Contrat introuvable.',
};

export const english: Record<string, string> = {
  ...Object.fromEntries(Object.keys(french).map(key => [key, key])),
  'Health coverage operations': 'Health coverage operations',
  'Coordinate member coverage in one workspace.': 'Coordinate member coverage in one workspace.',
  'Bring members, claims, guarantee letters, and contributions together in one clear workspace.': 'Bring members, claims, guarantee letters, and contributions together in one clear workspace.',
  'Explore capabilities': 'Explore capabilities',
  'Built for connected coverage work': 'Built for connected coverage work',
  'One view for the work behind member care.': 'One view for the work behind member care.',
  'Member and dependent records': 'Member and dependent records',
  'Keep profiles, contracts, eligibility, and family details organized.': 'Keep profiles, contracts, eligibility, and family details organized.',
  'Claims and guarantee letters': 'Claims and guarantee letters',
  'Follow reimbursements and guarantee letters through their workflows.': 'Follow reimbursements and guarantee letters through their workflows.',
  'Contributions and reporting': 'Contributions and reporting',
  'Review contribution activity alongside ledger and operational reports.': 'Review contribution activity alongside ledger and operational reports.',
  'One sign-in for members, institutions, and employers.': 'One sign-in for members, institutions, and employers.',
  'Healthcare team speaking with a patient': 'Healthcare team speaking with a patient',
  'Back to welcome page': 'Back to welcome page',
  ASSET: 'Asset', LIABILITY: 'Liability', EQUITY: 'Equity', REVENUE: 'Revenue', EXPENSE: 'Expense',
  'Guarantee letter type': 'Guarantee letter type',
  'Healthcare provider type': 'Healthcare provider type',
  'Payment details': 'Payment details',
  'Select a payment desk': 'Select a payment desk',
  'Loading payment sources...': 'Loading payment sources...',
  'No payment desks available.': 'No payment desks available.',
  'Update guarantee lines': 'Update guarantee lines',
  'Save guarantee lines': 'Save guarantee lines',
  TREATMENT: 'Treatment',
  PRESCRIPTION: 'Prescription',
  'Edit guarantee letter': 'Edit guarantee letter',
  'new.drugstores': 'New drugstore',
  'new.physicians': 'New physician',
  'new.banks': 'New bank',
  'new.payment-desks': 'New payment desk',
  NON_CADRE: 'NON-CADRE',
  'Document pending': 'Pending validation',
  'Document validated': 'Validated',
  'Document rejected': 'Rejected',
  'Reject claim': 'Reject claim',
  'Rejecting claim...': 'Rejecting claim...',
  'Record payment': 'Record payment',
  'Recording payment...': 'Recording payment...',
  'Payment date': 'Payment date',
  'Payment type': 'Payment type',
  'Select a payment type': 'Select a payment type',
  'Payment desk': 'Payment desk',
  Bank: 'Bank',
  'Bank account number': 'Bank account number',
  'Bank account BIC': 'Bank account BIC',
  'Select a bank': 'Select a bank',
  'Loading banks...': 'Loading banks...',
  'Unable to load banks.': 'Unable to load banks.',
  'No banks available.': 'No banks available.',
  'Mobile number': 'Mobile number',
  'See more': 'See more',
  'See less': 'See less',
  'Payment reference': 'Payment reference',
  'Payment reference (optional)': 'Payment reference (optional)',
  'Payment is recorded after an external transfer.': 'Payment is recorded after an external transfer.',
  'Claim rejected.': 'Claim rejected.',
  'Claim payment recorded.': 'Claim payment recorded.',
  CASH: 'Cash', BANK_TRANSFER: 'Bank transfer', MOBILE_WALLET: 'Mobile wallet',
  'Member tax rate (%)': 'Member tax rate (%)',
  'Company tax rate (%)': 'Company tax rate (%)',
  'Monthly salaries': 'Monthly salaries',
  Contributions: 'Contributions',
  'Refresh contributions': 'Refresh contributions',
  'Loading contributions...': 'Loading contributions...',
  'Unable to load member contributions.': 'Unable to load this member\'s contributions.',
  'No contributions for this member.': 'No contributions for this member.',
  'Mark as paid': 'Mark as paid',
  'Mark contribution as paid?': 'Mark contribution as paid?',
  'Outstanding amount': 'Outstanding amount',
  'Contribution marked as paid.': 'Contribution marked as paid.',
  'Cancel payment': 'Cancel payment',
  'Cancel contribution payment?': 'Cancel contribution payment?',
  'Cancelling payment...': 'Cancelling payment...',
  'Contribution payment cancelled.': 'Contribution payment cancelled.',
  'Cancel contribution': 'Cancel contribution',
  'Cancel this contribution?': 'Cancel this contribution?',
  'Cancelling contribution...': 'Cancelling contribution...',
  'Contribution cancelled.': 'Contribution cancelled.',
  'Unable to cancel contribution. Refresh and try again.': 'Unable to cancel contribution. Refresh and try again.',
  'Unable to cancel contribution payment. Refresh and try again.': 'Unable to cancel contribution payment. Refresh and try again.',
  'Unable to record contribution payment. Refresh and try again.': 'Unable to record contribution payment. Refresh and try again.',
  Year: 'Year',
  Month: 'Month',
  'Gross salary': 'Gross salary',
  Period: 'Period',
  'Refresh monthly salaries': 'Refresh monthly salaries',
  'Loading monthly salaries...': 'Loading monthly salaries...',
  'Unable to load monthly salaries.': 'Unable to load monthly salaries.',
  'Unable to load member salaries.': 'Unable to load this member\'s salaries.',
  'No monthly salaries for this member.': 'No monthly salaries for this member.',
  'Unable to add monthly salary.': 'Unable to add monthly salary.',
  'Unable to update monthly salary.': 'Unable to update monthly salary.',
  'Monthly salary already exists for this member and period.': 'A salary is already recorded for this member and period.',
  'No monthly salaries recorded for this company.': 'No monthly salaries recorded for this company.',
  'Refresh the company members list before adding a salary.': 'Refresh the company members list before adding a salary.',
  'Add monthly salary': 'Add monthly salary',
  'Edit monthly salary': 'Edit monthly salary',
  'Update monthly salary': 'Update monthly salary',
  HEALTH: 'Health', DISABILITY: 'Disability', LIFE_INSURANCE: 'Life insurance', RETIREMENT: 'Retirement',
  ANNUAL_BUDGET: 'Annual budget', PER_ACT_MAX: 'Maximum per act', QUANTITY_PER_YEAR: 'Quantity per year',
  SUPER_ADMIN: 'Super administrator',
  COMPANY: 'Company',
  'new.companies': 'New company',
  'Account menu for': 'Account menu for {{username}}',
  'Account details': 'Account details',
  'My details': 'My details',
  'Back to account menu': 'Back to account menu',
  'Application version': 'Application version',
  'Member login username': 'Member login username',
  'Member login password': 'Member login password',
  'Sign-in type': 'Sign-in type',
  'Staff access': 'Staff access',
  'Show password': 'Show password',
  'Hide password': 'Hide password',
  'Member access': 'Member access',
  'Member sign in': 'Member sign in',
  'Member username': 'Member username',
  'Member access requires a member account.': 'Member access requires a member account.',
  'Member accounts should use Member access.': 'Member accounts should use Member access.',
  'Member portal': 'Member portal',
  'Member portal sections': 'Member portal sections',
  'My information': 'My information',
  'My dependents': 'My dependents',
  'My claims': 'My claims',
  'My guarantee letters': 'My guarantee letters',
  Reporting: 'Reporting',
  'Reporting submenus': 'Reporting submenus',
  Processing: 'Processing',
  'Processing actions': 'Processing actions',
  'Batches today': 'Batches today',
  'Refresh batch history': 'Refresh batch history',
  'Loading batch history...': 'Loading batch history...',
  'Unable to load batch history.': 'Unable to load batch history.',
  'No batches today.': 'No batches today.',
  Started: 'Started',
  Batch: 'Batch',
  Result: 'Result',
  'Generate contributions': 'Generate contributions',
  'Copy salaries': 'Copy salaries',
  'Source year': 'Source year',
  'Source month': 'Source month',
  'Target year': 'Target year',
  'Target month': 'Target month',
  'Source and target periods must be different.': 'Source and target periods must be different.',
  'Start salary copy': 'Start salary copy',
  'Salary copy batch started.': 'Salary copy batch started.',
  'Salaries copied.': 'Salaries copied.',
  'Salary copy batch failed.': 'Salary copy batch failed.',
  'Contribution report': 'Contribution report',
  'Load report': 'Load report',
  'Loading contribution report...': 'Loading contribution report...',
  'Unable to load contribution report.': 'Unable to load contribution report.',
  'No contributions for this period.': 'No contributions for this period.',
  'Member rate (%)': 'Member rate (%)',
  'Company rate (%)': 'Company rate (%)',
  'Member contribution': 'Member contribution',
  'Company contribution': 'Company contribution',
  'Paid amount': 'Paid amount',
  'Contributions generated.': 'Contributions generated.',
  'No new contributions to generate.': 'No new contributions to generate.',
  'Ledger report': 'Ledger',
  'Audit report': 'Audit',
  'Guarantee letters report': 'Guarantee letters',
  'Claims report': 'Claims',
  OPERATOR: 'Operator', INSTITUTION: 'Institution', ADMIN: 'Administrator', USER: 'User',
  'new.letters': 'New guarantee letter',
  'Pick start date': 'Pick start date',
  'Pick end date': 'Pick end date',
  'Download report PDF': 'Download report PDF',
  'Download guarantee letter PDF': 'Download guarantee letter PDF',
  'Validate guarantee letter': 'Validate guarantee letter',
  'Cancel guarantee-letter payment': 'Cancel guarantee-letter payment',
  'Guarantee-letter payment cancelled.': 'Guarantee-letter payment cancelled.',
  'Unable to cancel guarantee-letter payment.': 'Unable to cancel guarantee-letter payment.',
  'Mark guarantee letter as paid': 'Mark guarantee letter as paid',
  'Guarantee letter marked as paid.': 'Guarantee letter marked as paid.',
  'Unable to pay guarantee letter.': 'Unable to pay guarantee letter.',
  'Enter valid dates in dd/mm/yyyy order.': 'Enter valid dates in dd/mm/yyyy order.',
  'Unable to cancel guarantee letter.': 'Unable to cancel guarantee letter.',
  DRAFT: 'Draft', ISSUED: 'Issued', VALIDATED: 'Validated', CANCELLED: 'Cancelled', EXPIRED: 'Expired',
  'new.members': 'New member', 'new.dependents': 'New dependent',
  'new.claims': 'New claim', 'new.contracts': 'New contract',
  'new.providers': 'New insurer provider', 'new.treatments': 'New treatment',
  'new.healthcare': 'New healthcare provider', 'new.drugs': 'New drug',
  'Search section': 'Search {{section}}',
  'recordCount.one': '{{count}} record', 'recordCount.other': '{{count}} records',
  'Request failed': 'Request failed ({{status}}).',
  PENDING: 'Pending', PROCESSED: 'Processed', REJECTED: 'Rejected', PAID: 'Paid',
  PARTIALLY_PAID: 'Partially paid',
  SPOUSE: 'Spouse', CHILD: 'Child', OTHER_DEPENDENT: 'Other dependent',
  PHARMACY: 'Pharmacy', HOSPITAL: 'Hospital', OPTICIAN: 'Optician', DENTIST: 'Dentist', PHYSICIAN: 'Physician',
};

export const wolof: Record<string, string> = {
  ...english,
  Language: 'L\u00e0kk',
  French: 'Franse',
  English: 'Angale',
  Wolof: 'Wolof',
  Theme: 'Melokaan',
  'Sign in': 'Duggal',
  'Sign out': 'G\u00e9nn',
  Reporting: 'Rapoor',
  Cancel: 'Dakkal',
  'Save changes': 'Denc coppite yi',
  'Search records': 'Seet bind yi',
};